/* Auto-extracted from LanguageContext.tsx. One locale per file.
   Keep keys in sync across en/tr. */
export const tr: Record<string, string> = {
    // --- Redesign additions ---
    'nav.manage': 'Yönet',
    'nav.account': 'Hesap',
    'notifications.title': 'Bildirimler',
    'notifications.markAllRead': 'Tümünü okundu işaretle',
    'notifications.empty': 'Henüz bildirim yok',
    'auth.register.companySection': 'Şirket',
    'auth.register.accountSection': 'Hesap',
    'auth.register.strengthWeak': 'Zayıf şifre',
    'auth.register.strengthFair': 'Orta şifre',
    'auth.register.strengthGood': 'İyi şifre',
    'auth.register.strengthStrong': 'Güçlü şifre',
    'dashboard.resetLayout': 'Düzeni sıfırla',
    'dashboard.actions.unreplied': 'Yanıtlanmamış yorumlar',
    'dashboard.actions.recentNegative': 'Bu haftaki olumsuz yorumlar',
    'dashboard.actions.allClear': 'Her şey yolunda',
    'dashboard.actions.allClearDesc': 'İlgilenmeniz gereken bekleyen bir işlem yok.',
    'review.clearFilters': 'Filtreleri temizle',
    'review.recommended': 'Önerilen',
    'footer.privacy': 'Gizlilik Politikası',
    'footer.terms': 'Kullanım Koşulları',
    'footer.cookies': 'Çerez Politikası',
    'landing.preview.businesses': 'İşletmeler',
    'subscription.statusInactive': 'Pasif',
    'subscription.statusPending': 'Beklemede',
    'agency.searchClients': 'Müşteri ara...',
    'agency.noClientsDescription': 'Ajansınıza müşteri eklediğinizde burada görünecekler.',
    'agency.noClientsMatch': 'Eşleşen müşteri yok',
    'agency.noClientsMatchDescription': 'Arama terimlerinizi değiştirmeyi deneyin.',
    'apiKeys.newKeyTitle': 'Yeni API anahtarınız',
    'apiKeys.keyConfirm': 'Anahtarımı kopyaladım',
    'apiKeys.copyWarningDetail': 'Güvenlik nedeniyle bu anahtar tekrar gösterilmeyecek. Güvenli bir yerde saklayın.',
    'common.copied': 'Kopyalandı',
    'auth.hero.tag1': '4.8★',
    'auth.hero.tag2': '1.200+ yorum/gün',
    'auth.hero.tag3': 'AI destekli',
    'auth.hero.title': 'Google yorumlarınızı 60 saniyede anlayın',
    'auth.hero.description': "Türkiye'nin önde gelen restoran ve otel zincirleri Revomira ile itibarlarını yönetiyor.",
    'auth.hero.period': 'Son 30 gün',
    'auth.hero.growth': '↑ +12.3%',
    'auth.hero.statReviews': 'Toplam Yorum',
    'auth.hero.statRating': 'Ortalama Puan',
    'auth.hero.statResponse': 'Yanıt Oranı',
    'auth.hero.footer': '© 2026 Revomira. Türkiye\'de üretildi.',
    'auth.hero.backHome': '← Ana sayfaya dön',

    // Page Title
    'page.title': 'Revomira - Yorumların ötesini görün',
    
    // Navigation
    'nav.home': 'Ana Sayfa',
    'nav.signIn': 'Giriş Yap',
    'nav.getStarted': 'Başlayın',
    'nav.about': 'Hakkımızda',
    'nav.contact': 'İletişim',
    'nav.openMenu': 'Menüyü aç',
    'nav.closeMenu': 'Menüyü kapat',
    
    // Hero
    'hero.badge': '🚀 Türkiye pazarı için hazır',
    'hero.title': 'Google yorumlarınızı 60 saniyede anlayın',
    'hero.titleHighlight': 'görün',
    'hero.subtitle': 'Tüm işletmelerinizin yorumlarını tek yerden yönetin, AI ile analiz edin, doğrudan yanıt gönderin.',
    'hero.subcopy': "Türkiye'deki restoran, otel ve perakende zincirleri için",
    'hero.cta.start': 'Ücretsiz Başla — Kredi kartı gerekmez',
    'hero.cta.demo': 'Demo İzle',
    
    // Features
    'features.title': 'İtibarınızı yönetmek için ihtiyacınız olan her şey',
    'features.subtitle': 'Modern işletmeler için tasarlanmış güçlü özellikler',
    'features.ai.title': 'AI Destekli İçgörüler',
    'features.ai.desc': 'Duygu analizi ve işlenebilir içgörülerle yorumlarınızın akıllı analizini alın.',
    'features.platform.title': 'Çoklu Platform Entegrasyonu',
    'features.platform.desc': "Google My Business'i şimdi bağlayın; TripAdvisor, Booking.com ve daha fazlası yakında geliyor.",
    'features.analytics.title': 'Gelişmiş Analitikler',
    'features.analytics.desc': 'Tüm platformlarda itibarınızı takip etmek için kapsamlı raporlama ve analitikler.',
    'features.security.title': 'Kurumsal Güvenlik',
    'features.security.desc': 'Rol tabanlı erişim kontrolü ve veri şifreleme ile banka seviyesinde güvenlik.',
    'features.realtime.title': 'Gerçek Zamanlı İzleme',
    'features.realtime.desc': 'Tüm platformlarda yeni yorumlar yayınlandığında anında bildirimler alın.',
    'features.team.title': 'Takım İşbirliği',
    'features.team.desc': 'Organizasyonunuz için farklı izin seviyelerine sahip birden fazla kullanıcıyı yönetin.',
    
    // Pricing
    'pricing.title': 'Basit, şeffaf fiyatlandırma',
    'pricing.subtitle': 'İşletmeniz için doğru planı seçin',
    'pricing.monthly': 'Aylık',
    'pricing.yearly': 'Yıllık',
    'pricing.save': '%20 Tasarruf',
    'pricing.basic.name': 'Temel',
    'pricing.basic.desc': 'Küçük işletmeler için ideal',
    'pricing.professional.name': 'Profesyonel',
    'pricing.professional.desc': 'Büyüyen işletmeler için',
    'pricing.enterprise.name': 'Kurumsal',
    'pricing.enterprise.desc': 'Ajanslar ve çoklu şube işletmeleri için',
    'pricing.mostPopular': 'En Popüler',
    'pricing.getStarted': 'Başlayın',
    'pricing.month': 'ay',
    'pricing.year': 'yıl',
    'pricing.basic.feature1': 'En fazla 5 işletme',
    'pricing.basic.feature2': 'Google My Business entegrasyonu',
    'pricing.basic.feature3': 'Temel analitikler',
    'pricing.basic.feature4': 'E-posta desteği',
    'pricing.basic.feature5': '1 kullanıcı hesabı',
    'pricing.professional.feature1': 'En fazla 25 işletme',
    'pricing.professional.feature2': 'Tüm platform entegrasyonları',
    'pricing.professional.feature3': 'Gelişmiş analitikler ve AI içgörüleri',
    'pricing.professional.feature4': 'Öncelikli destek',
    'pricing.professional.feature5': 'En fazla 10 kullanıcı hesabı',
    'pricing.professional.feature6': 'Özel raporlama',
    'pricing.enterprise.feature1': 'Sınırsız işletme',
    'pricing.enterprise.feature2': 'Tüm platform entegrasyonları',
    'pricing.enterprise.feature3': 'Gelişmiş AI ve makine öğrenmesi',
    'pricing.enterprise.feature5': 'Sınırsız kullanıcı hesabı',
    'pricing.enterprise.feature6': 'API erişimi',

    // Testimonials
    'testimonials.title': 'Dünya çapında işletmeler tarafından güveniliyor',
    'testimonials.subtitle': 'Müşterilerimizin söylediklerini görün',
    
    // CTA
    'cta.title': 'İtibar yönetiminizi dönüştürmeye hazır mısınız?',
    'cta.subtitle': 'Online itibarlarını yönetmek için Revomira\'yı kullanan binlerce işletmeye katılın.',
    'cta.start': 'Ücretsiz Deneme Başlat',
    'cta.contact': 'Satış Ekibiyle İletişim',

    // Onboarding
    'onboarding.modalTitle': 'Hoş geldiniz',
    'onboarding.welcome.title': "Revomira'ya hoş geldiniz",
    'onboarding.welcome.subtitle': '14 günlük denemeniz başladı. İlk kurulumu tamamlayalım.',
    'onboarding.welcome.cta': 'Başlayalım',
    'onboarding.connect.title': 'Google İşletme Profilinizi bağlayın',
    'onboarding.connect.subtitle': 'Yorumları otomatik çekmek için bir işletme bağlayın.',
    'onboarding.connect.connectButton': 'Platform Bağla',
    'onboarding.connect.skipButton': 'Şimdi Değil',
    'onboarding.ready.title': 'Hazırsınız',
    'onboarding.ready.completing': 'Tamamlanıyor...',
    'onboarding.ready.syncing': 'Senkronize ediliyor...',
    'onboarding.ready.goToDashboard': 'Dashboard\'a geç',
    'onboarding.sync.ready': 'İlk senkronizasyonu başlatmaya hazır.',
    'onboarding.sync.checkingConnections': 'Bağlı platformlar kontrol ediliyor...',
    'onboarding.sync.businessNotFound': 'İşletme bulunamadı. Dashboard\'dan ilk işletmenizi ekleyebilirsiniz.',
    'onboarding.sync.noPlatformConnected': 'Henüz platform bağlanmadı. İşletmeler ekranından bağlayabilirsiniz.',
    'onboarding.sync.fetchingReviews': 'İlk yorumlar getiriliyor...',
    'onboarding.sync.completed': 'İlk senkronizasyon tamamlandı.',
    'onboarding.sync.failed': 'İlk senkronizasyon şimdilik başlatılamadı. Dashboard\'dan tekrar deneyebilirsiniz.',
    
    // Footer
    'footer.description': 'Modern işletmeler için AI destekli yorum yönetim platformu.',
    'footer.copyright': '© 2025 Revomira. Tüm hakları saklıdır.',
    
    // SEO
    'seo.login.title': 'Giriş | Revomira',
    'seo.register.title': 'Kayıt Ol | Revomira',
    'seo.privacy.title': 'Gizlilik Politikası | Revomira',
    'seo.privacy.description': 'Revomira gizlilik politikası ve kişisel veri işleme uygulamaları.',
    'seo.terms.title': 'Kullanım Koşulları | Revomira',
    'seo.terms.description': 'Revomira platformunu kullanım şartları.',
    'seo.contact.title': 'İletişim | Revomira',
    'seo.about.title': 'Hakkımızda | Revomira',
    'seo.forgotPassword.title': 'Şifremi Unuttum | Revomira',
    'seo.setupPassword.title': 'Şifre Oluştur | Revomira',
    'seo.cookie.title': 'Çerez Politikası | Revomira',
    'seo.cookie.description': 'Revomira çerezleri ve benzer teknolojileri nasıl kullanır.',

    // Auth
    'auth.login.title': 'Giriş Yap',
    'auth.login.subtitle': 'Devam etmek için bilgilerinizi girin',
    'auth.login.email': 'E-posta',
    'auth.login.emailPlaceholder': 'E-posta adresinizi girin',
    'auth.login.password': 'Şifre',
    'auth.login.passwordPlaceholder': 'Şifrenizi girin',
    'auth.login.remember': 'Beni hatırla',
    'auth.login.forgotPassword': 'Şifremi unuttum?',
    'auth.login.signIn': 'Giriş Yap',
    'auth.login.signingIn': 'Giriş yapılıyor...',
    'auth.login.noAccount': 'Hesabınız yok mu?',
    'auth.login.requestAccess': 'Erişim iste',
    'auth.login.welcomeBack': 'Tekrar hoş geldiniz!',
    'auth.login.success': 'Başarıyla giriş yaptınız.',
    'auth.login.failed': 'Giriş başarısız',
    'auth.login.invalid': 'Geçersiz e-posta veya şifre',
    'auth.login.userNotFound': 'Kullanıcı bulunamadı',
    'auth.login.accountPending': 'Hesap onay bekliyor. Lütfen önce kurulum bağlantısı ile şifrenizi belirleyin.',
    'auth.login.accountInactive': 'Kullanıcı hesabı aktif değil',
    'auth.login.mustSetPassword': 'Önce kurulum bağlantısı ile şifrenizi belirlemeniz gerekir',
    'auth.login.organizationNotFound': 'Organizasyon bulunamadı',
    
    'auth.register.title': 'Hesap Oluştur',
    'auth.register.subtitle': 'Organizasyonunuzu kaydedin',
    'auth.register.companyName': 'Şirket Adı',
    'auth.register.companyNamePlaceholder': 'Şirket adınızı girin',
    'auth.register.contactName': 'İletişim Adı',
    'auth.register.contactNamePlaceholder': 'Adınızı ve soyadınızı girin',
    'auth.register.contactEmail': 'İletişim E-postası',
    'auth.register.contactEmailPlaceholder': 'E-posta adresinizi girin',
    'auth.register.phoneNumber': 'Telefon Numarası (Opsiyonel)',
    'auth.register.phoneNumberPlaceholder': 'Telefon numaranızı girin',
    'auth.register.submit': 'Talep Gönder',
    'auth.register.submitting': 'Talep gönderiliyor...',
    'auth.register.submitted': 'Kayıt talebi gönderildi!',
    'auth.register.submittedDesc': 'Talebinizi inceleyeceğiz ve 24 saat içinde size geri dönüş yapacağız.',
    'auth.register.alreadyHave': 'Zaten bir hesabınız var mı?',
    'auth.register.signIn': 'Giriş yap',
    'auth.register.backToSignIn': 'Giriş Sayfasına Dön',
    'auth.register.whatNext': 'Sırada ne var?',
    'auth.register.review': 'Ekibimiz başvurunuzu inceleyecek',
    'auth.register.email': 'Onay durumunuzla ilgili bir e-posta alacaksınız',
    'auth.register.approved': 'Onaylanırsa, kurulum talimatlarını alacaksınız',
    'auth.register.start': 'Hemen yorumlarınızı yönetmeye başlayın',
    'auth.register.whatExpect': 'Neler beklenmeli:',
    'auth.register.quickApproval': 'Hızlı onay süreci (genellikle 24 saat içinde)',
    'auth.register.freeTrial': 'Tüm özelliklere tam erişimli ücretsiz deneme',
    'auth.register.support': 'Özel onboarding desteği',
    'auth.register.noCreditCard': 'Deneme için kredi kartı gerekmez',
    'auth.register.failed': 'Kayıt başarısız',
    'auth.register.tryAgain': 'Lütfen daha sonra tekrar deneyin',
    'auth.register.alreadyExists': 'Bu e-posta veya şirket zaten kayıtlı',
    'auth.register.acceptTerms': 'Kabul ediyorum',
    'auth.register.privacyPolicy': 'Gizlilik Politikası',
    'auth.register.termsOfService': 'Kullanım Koşulları',
    'auth.register.cookiePolicy': 'Çerez Politikası',
    'auth.register.termsRequired': 'Devam etmek için Gizlilik Politikası ve Çerez Politikasını kabul etmelisiniz',
    'auth.register.kvkkRequired': 'KVKK açık rıza onayı zorunludur.',
    'auth.register.kvkkConsentLabel': "KVKK Aydınlatma Metni'ni okudum ve kişisel verilerimin işlenmesine açık rıza veriyorum.",
    'auth.register.kvkkViewButton': 'KVKK Metnini Görüntüle',
    'auth.register.successAccountCreated': 'Hesabınız oluşturuldu',
    'auth.register.successSignIn': 'E-posta ve şifrenizle giriş yapabilirsiniz',
    'auth.register.successOnboarding': 'Onboarding adımlarıyla ilk kurulumu tamamlayın',
    'auth.register.successStartAnalysis': 'İlk yorum analizinizi hemen başlatın',
    'auth.register.afterRegisterSignIn': 'Kayıt sonrası hemen giriş yapabilirsiniz',

    'dashboard.trial.daysRemaining': '{days} gün deneme süreniz kaldı',
    'dashboard.trial.active': 'Deneme süreniz aktif',
    'dashboard.trial.upgrade': 'Planı Yükselt',
    'dashboard.customLayout': 'Özelleştirilebilir panel düzeni',
    'dashboard.dragHint': 'Widget sırasını değiştirmek için kartlardaki sürükle tutamacını kullanın. Tutamacı odaklayıp ok tuşlarıyla sıralayabilirsiniz.',
    'dashboard.dragHandle': 'Widget sırasını değiştirmek için sürükleyin',
    'dashboard.empty.title': 'Başlamak için ilk işletmenizi ekleyin',
    'dashboard.empty.description': 'Yorumları senkronize etmek ve analitikleri açmak için Google İşletme Profilinizi bağlayın.',
    'dashboard.empty.cta': 'İşletme Ekle',
    'dashboard.charts.orgScopeHint': 'Grafikler tüm işletmeleri kapsar; gelişmiş analitikler seçilen işletme içindir.',

    'apiKeys.title': 'API Anahtarları',
    'apiKeys.labelPlaceholder': 'Anahtar etiketi (ör. Üretim)',
    'apiKeys.create': 'Anahtar oluştur',
    'apiKeys.copyWarning': 'Bu anahtarı şimdi kopyalayın — bir daha gösterilmeyecek.',
    'apiKeys.revoke': 'İptal et',
    'apiKeys.revokeConfirm': 'Bu anahtarı iptal etmek istediğinizden emin misiniz?',
    'apiKeys.empty': 'Henüz API anahtarı yok.',
    'apiKeys.lastUsed': 'Son kullanım',
    'apiKeys.never': 'Hiç',
    'apiKeys.scopeReviews': 'Yorumlar (okuma)',
    'apiKeys.scopeAnalytics': 'Analitik (okuma)',
    'apiKeys.active': 'Aktif',
    'apiKeys.revoked': 'İptal edildi',
    'apiKeys.created': 'Oluşturuldu',

    'agency.title': 'Ajans',
    'agency.clients': 'Ajans Müşterileri',
    'agency.rating': 'Ort. puan (30g)',
    'agency.unresponded': 'Yanıtsız yorumlar',
    'agency.subscription': 'Abonelik',
    'agency.openDashboard': 'Paneli aç',
    'agency.noClients': 'Henüz bağlı müşteri organizasyonu yok.',
    'agency.switchContext': 'Bu hesaba geç',
    'agency.viewingAsClient': 'Bir müşteri organizasyonunu görüntülüyorsunuz',
    'agency.returnToAgency': 'Ajansa dön',

    'landing.preview.reviews': 'Yorumlar',
    'landing.preview.avgRating': 'Ort. puan',
    'landing.preview.responseRate': 'Yanıt oranı',

    'common.comingSoon': 'Yakında',
    'businessDetail.comingSoonPlatformsDescription': 'Ek entegrasyonlar yakında geliyor',

    'settings.profile.namePlaceholder': 'Adınızı girin',
    'settings.profile.emailPlaceholder': 'E-posta adresinizi girin',
    'settings.password.currentPlaceholder': 'Mevcut şifrenizi girin',
    'settings.password.newPlaceholder': 'Yeni şifrenizi girin (en az 8 karakter)',
    'settings.password.confirmPlaceholder': 'Yeni şifrenizi onaylayın',

    'subscription.upgradeModalTitle': 'Plan Yükseltme Gerekli',
    'subscription.upgradeLimitReached': 'Plan limitinize ulaştınız.',
    'subscription.currentPlanLabel': 'Mevcut plan',
    'subscription.limitTypeLabel': 'Limit tipi',
    'subscription.professionalPlanPrice': 'Profesyonel Plan — 999 TRY/ay',
    'subscription.upgradeProfessionalDesc': 'Doğrudan yanıt gönderimi ve gelişmiş limitler.',

    'landing.howItWorks.title': 'Nasıl çalışır',
    'landing.howItWorks.subtitle': 'Üç basit adımda başlayın',
    'landing.howItWorks.step1.title': 'İşletmenizi bağlayın',
    'landing.howItWorks.step1.desc': 'Google İşletme Profilinizi dakikalar içinde bağlayın.',
    'landing.howItWorks.step2.title': 'Yorumları otomatik senkronize edin',
    'landing.howItWorks.step2.desc': 'Tüm yorumlar tek bir panele akar.',
    'landing.howItWorks.step3.title': 'AI içgörüleriyle yanıtlayın',
    'landing.howItWorks.step3.desc': 'Duygu analizi yapın ve daha hızlı yanıt verin.',
    'landing.pilot.title': 'Pilot Programa Katılın',
    'landing.pilot.subtitle': 'İlk işletmeleri yönlendirmeli kurulum ve hızlı geri bildirim süreciyle onboard ediyoruz.',
    'landing.pilot.cta': 'İlk 100 işletme arasına katılın',
    
    'auth.forgotPassword.title': 'Şifre Sıfırla',
    'auth.forgotPassword.subtitle': 'Size sıfırlama bağlantısı göndereceğiz',
    'auth.forgotPassword.email': 'E-posta',
    'auth.forgotPassword.emailPlaceholder': 'E-posta adresinizi girin',
    'auth.forgotPassword.send': 'Sıfırlama bağlantısı gönder',
    'auth.forgotPassword.sending': 'Gönderiliyor...',
    'auth.forgotPassword.sent': 'E-posta gönderildi',
    'auth.forgotPassword.sentDesc': 'Bu e-posta ile bir hesap varsa, şifre sıfırlama talimatlarını alacaksınız.',
    'auth.forgotPassword.checkEmail': 'E-postanızı kontrol edin',
    'auth.forgotPassword.checkDesc': 'Bir hesap varsa',
    'auth.forgotPassword.checkDesc2': 'şifre sıfırlama talimatlarını alacaksınız.',
    'auth.forgotPassword.sendAnother': 'Başka bir e-posta gönder',
    'auth.forgotPassword.backToLogin': 'Giriş sayfasına dön',
    'auth.forgotPassword.notFound': 'Hesap bulunamadı',
    'auth.forgotPassword.notFoundDesc': 'Bu e-posta adresiyle bir hesap bulunmuyor. Lütfen e-posta adresinizi kontrol edin veya yeni bir hesap oluşturun.',
    'auth.forgotPassword.pending': 'Hesap bekliyor',
    'auth.forgotPassword.pendingDesc': 'Organizasyon kaydınız hala onay bekliyor. Lütfen yöneticinizle iletişime geçin veya onay bekleyin.',
    'auth.forgotPassword.rateLimit': 'Başka bir e-posta göndermeden önce lütfen bekleyin',
    'auth.forgotPassword.rateLimitDesc': '{seconds} saniye sonra başka bir e-posta gönderebilirsiniz.',
    'auth.forgotPassword.error': 'Hata',
    'auth.forgotPassword.errorDesc': 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
    'auth.forgotPassword.tryAgain': 'Tekrar dene',
    
    'auth.setupPassword.title': 'Şifrenizi Belirleyin',
    'auth.setupPassword.subtitle': 'Hesabınız için güvenli bir şifre oluşturun',
    'auth.setupPassword.email': 'E-posta',
    'auth.setupPassword.emailPlaceholder': 'E-posta adresinizi girin',
    'auth.setupPassword.password': 'Yeni Şifre',
    'auth.setupPassword.passwordPlaceholder': 'Yeni şifrenizi girin',
    'auth.setupPassword.confirmPassword': 'Şifreyi Onayla',
    'auth.setupPassword.confirmPasswordPlaceholder': 'Şifrenizi onaylayın',
    'auth.setupPassword.setPassword': 'Şifreyi Belirle',
    'auth.setupPassword.setting': 'Şifre belirleniyor...',
    'auth.setupPassword.success': 'Şifre başarıyla belirlendi!',
    'auth.setupPassword.successDesc': 'Şifreniz belirlendi. Artık giriş yapabilirsiniz.',
    'auth.setupPassword.failed': 'Şifre belirleme başarısız',
    'auth.setupPassword.invalidToken': 'Geçersiz veya süresi dolmuş token',
    'auth.setupPassword.invalidTokenDesc': 'Şifre belirleme bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir tane isteyin.',
    'auth.setupPassword.tokenRequired': 'Token gerekli',
    'auth.setupPassword.tokenRequiredDesc': 'Lütfen şifrenizi belirlemek için e-postanızdaki bağlantıyı kullanın.',
    'auth.setupPassword.backToLogin': 'Giriş sayfasına dön',
    
    // Contact
    'contact.title': 'İletişime Geçin',
    'contact.subtitle': 'Sizden haber almak isteriz. Bize bir mesaj gönderin, en kısa sürede yanıtlayacağız.',
    'contact.form.name': 'Ad',
    'contact.form.email': 'E-posta',
    'contact.form.phone': 'Telefon',
    'contact.form.subject': 'Konu',
    'contact.form.message': 'Mesaj',
    'contact.form.messagePlaceholder': 'Sorunuz hakkında daha fazla bilgi verin...',
    'contact.form.optional': 'İsteğe Bağlı',
    'contact.form.send': 'Mesaj Gönder',
    'contact.form.sending': 'Gönderiliyor...',
    'contact.form.sentSuccess': 'Mesaj Başarıyla Gönderildi!',
    'contact.form.sentSuccessDesc': 'En kısa sürede size geri dönüş yapacağız.',
    'contact.info.title': 'İletişim Bilgileri',
    'contact.info.email': 'E-posta',
    'contact.info.emailValue': 'info@revomira.com',
    'contact.nameRequired': 'Ad zorunludur',
    'contact.emailRequired': 'E-posta zorunludur',
    'contact.emailInvalid': 'Geçerli bir e-posta girin',
    'contact.messageRequired': 'Mesaj zorunludur',

    // About
    'about.title': 'Revomira Hakkında',
    'about.subtitle': 'İşletmelerin online itibar yönetimini dönüştürmelerine yardımcı oluyoruz',
    'about.mission.title': 'Misyonumuz',
    'about.mission.desc': 'Müşteri geri bildirimlerini işlenebilir içgörülere dönüştüren AI destekli araçlarla her büyüklükteki işletmeyi güçlendirmek, müşterileriyle daha güçlü ilişkiler kurmalarına ve itibarlarını büyütmelerine yardımcı olmak.',
    'about.vision.title': 'Vizyonumuz',
    'about.vision.desc': 'Online itibar yönetimi için önde gelen platform olmak, dünya çapındaki işletmeler tarafından tüm platformlarda müşteri geri bildirimlerini yönetmek, analiz etmek ve yanıtlamak için güvenilir.',
    'about.values.title': 'Değerlerimiz',
    'about.values.innovation': 'Yenilik',
    'about.values.innovation.desc': 'En son çözümler sunmak için sürekli yenilik yapıyoruz.',
    'about.values.customer': 'Müşteri Odaklı',
    'about.values.customer.desc': 'Müşterilerimizin başarısı bizim başarımızdır.',
    'about.values.integrity': 'Dürüstlük',
    'about.values.integrity.desc': 'Yaptığımız her şeyde şeffaflık ve dürüstlükle çalışıyoruz.',
    
    // Dashboard
    'dashboard.overview': 'Genel Bakış',
    'dashboard.stats.activePlatforms': 'Aktif Platform',
    'dashboard.recentReviews': 'Son Yorumlar',
    'dashboard.newBusinesses': 'Yeni İşletmeler',
    
    // Settings
    'settings.title': 'Ayarlar',
    'settings.subtitle': 'Hesap ayarlarınızı ve tercihlerinizi yönetin',
    'settings.profile.title': 'Profil Bilgileri',
    'settings.profile.subtitle': 'Kişisel bilgilerinizi güncelleyin',
    'settings.profile.fullName': 'Ad Soyad',
    'settings.profile.email': 'E-posta Adresi',
    'settings.security.title': 'Güvenlik',
    'settings.security.subtitle': 'Hesabınızı güvende tutmak için şifrenizi değiştirin',
    'settings.security.currentPassword': 'Mevcut Şifre',
    'settings.security.newPassword': 'Yeni Şifre',
    'settings.security.confirmPassword': 'Yeni Şifreyi Onayla',
    'settings.preferences.title': 'Tercihler',
    'settings.preferences.subtitle': 'Deneyiminizi özelleştirin',
    'settings.preferences.theme': 'Tema',
    'settings.preferences.lightMode': 'Açık mod',
    'settings.preferences.darkMode': 'Koyu mod',
    'settings.preferences.language': 'Dil',
    'settings.account.title': 'Hesap Detayları',
    'settings.account.subtitle': 'Hesap bilgileriniz',
    'settings.account.role': 'Rol',
    'settings.account.organization': 'Organizasyon',
    'settings.account.status': 'Durum',
    'settings.account.memberSince': 'Üyelik tarihi',
    'settings.managedBusinesses.title': 'Yönetilen İşletmeler',
    'settings.managedBusinesses.subtitle': 'Yönetmek için erişiminiz olan işletmeler',
    'settings.team.title': 'Ekip Üyeleri',
    'settings.team.subtitle': 'Kuruluşunuza katılmaları için kişileri davet edin',
    'settings.team.emailPlaceholder': 'meslektas@ornek.com',
    'settings.team.sendInvite': 'Davet Gönder',
    'settings.team.sending': 'Gönderiliyor...',
    'settings.team.noPendingInvites': 'Bekleyen davet yok',
    'settings.team.email': 'E-posta',
    'settings.team.expiresAt': 'Son Geçerlilik',
    'settings.team.resend': 'Daveti yeniden gönder',
    'settings.team.revoke': 'Daveti iptal et',
    'settings.team.revokeConfirm': 'Bu davet iptal edilsin mi? Alıcı artık bu daveti kabul edemeyecek.',
    'settings.team.inviteSent': 'Davet gönderildi',
    'settings.team.inviteSentDescription': 'Bir davet e-postası gönderildi.',
    'settings.team.inviteResent': 'Davet yeniden gönderildi',
    'settings.team.inviteRevoked': 'Davet iptal edildi',
    'settings.team.inviteFailed': 'Davet işlenemedi',
    'settings.team.statusPending': 'Beklemede',
    'settings.team.statusAccepted': 'Kabul Edildi',
    'settings.team.statusDeclined': 'Reddedildi',
    'settings.team.statusExpired': 'Süresi Doldu',
    'settings.team.statusRevoked': 'İptal Edildi',
    'settings.digest.title': 'Özet Raporlar',
    'settings.digest.subtitle': 'Yorum etkinliğinizin otomatik e-posta özetleri',
    'settings.digest.enable': 'Özet raporlarını etkinleştir',
    'settings.digest.dailyEnable': 'Günlük özet',
    'settings.digest.weeklyEnable': 'Haftalık özet',
    'settings.digest.sendTime': 'Gönderim saati',
    'settings.digest.sendNow': 'Şimdi gönder',
    'settings.digest.recipients': 'Ek alıcılar',
    'settings.digest.recipientPlaceholder': 'birisi@ornek.com',
    'settings.digest.saved': 'Özet ayarları kaydedildi',
    'settings.digest.saveFailed': 'Özet ayarları kaydedilemedi',
    'settings.digest.testSent': 'Test özeti gönderildi',
    'settings.digest.testSendFailed': 'Özet gönderilemedi',
    'settings.digest.sunday': 'Pazar',
    'settings.digest.monday': 'Pazartesi',
    'settings.digest.tuesday': 'Salı',
    'settings.digest.wednesday': 'Çarşamba',
    'settings.digest.thursday': 'Perşembe',
    'settings.digest.friday': 'Cuma',
    'settings.digest.saturday': 'Cumartesi',

    // Alert thresholds
    'settings.alerts.title': 'Uyarı Eşikleri',
    'settings.alerts.subtitle': 'Belirlediğiniz eşik değerleri aşıldığında bildirim alın',
    'settings.alerts.name': 'Ad',
    'settings.alerts.thresholdType': 'Metrik',
    'settings.alerts.condition': 'Koşul',
    'settings.alerts.value': 'Değer',
    'settings.alerts.cooldownMinutes': 'Bekleme süresi (dakika)',
    'settings.alerts.create': 'Eşik Oluştur',
    'settings.alerts.update': 'Eşiği Güncelle',
    'settings.alerts.edit': 'Düzenle',
    'settings.alerts.delete': 'Sil',
    'settings.alerts.created': 'Uyarı eşiği oluşturuldu',
    'settings.alerts.updated': 'Uyarı eşiği güncellendi',
    'settings.alerts.deleted': 'Uyarı eşiği silindi',
    'settings.alerts.saveFailed': 'Uyarı eşiği kaydedilemedi',
    'settings.alerts.deleteConfirm': 'Bu uyarı eşiği silinsin mi?',
    'settings.alerts.noThresholds': 'Henüz bir uyarı eşiği tanımlanmadı',
    'settings.alerts.checkNow': 'Şimdi kontrol et',
    'settings.alerts.checkComplete': 'Eşik kontrolü tamamlandı',
    'settings.alerts.checkResult': '{count} uyarı tetiklendi',
    'settings.alerts.activeAlerts': 'Aktif uyarılar',
    'settings.alerts.resolve': 'Çöz',
    'settings.alerts.type.ratingAverage': 'Ortalama puan',
    'settings.alerts.type.negativeReviewCount': 'Olumsuz yorum sayısı',
    'settings.alerts.type.responseTime': 'Yanıt süresi',
    'settings.alerts.type.sentimentScore': 'Duygu puanı',
    'settings.alerts.type.reviewCount': 'Yorum sayısı',
    'settings.alerts.type.unresolvedReviewCount': 'Yanıtsız yorum sayısı',
    'settings.alerts.condition.below': 'altında',
    'settings.alerts.condition.above': 'üstünde',
    'settings.alerts.condition.equals': 'eşit',

    // Response templates
    'settings.templates.title': 'Yanıt Şablonları',
    'settings.templates.subtitle': 'Sık karşılaşılan durumlar için hazır yanıt şablonları',
    'settings.templates.name': 'Ad',
    'settings.templates.category': 'Kategori',
    'settings.templates.content': 'Şablon metni',
    'settings.templates.contentPlaceholder': '{{customerName}}, {{rating}} yıldızlı yorumunuz için teşekkür ederiz...',
    'settings.templates.create': 'Şablon Oluştur',
    'settings.templates.update': 'Şablonu Güncelle',
    'settings.templates.edit': 'Düzenle',
    'settings.templates.delete': 'Sil',
    'settings.templates.favorite': 'Favori',
    'settings.templates.created': 'Yanıt şablonu oluşturuldu',
    'settings.templates.updated': 'Yanıt şablonu güncellendi',
    'settings.templates.deleted': 'Yanıt şablonu silindi',
    'settings.templates.saveFailed': 'Yanıt şablonu kaydedilemedi',
    'settings.templates.deleteConfirm': 'Bu yanıt şablonu silinsin mi?',
    'settings.templates.noTemplates': 'Henüz bir yanıt şablonu yok',
    'settings.templates.category.positive': 'Olumlu',
    'settings.templates.category.negative': 'Olumsuz',
    'settings.templates.category.neutral': 'Nötr',
    'settings.templates.category.apology': 'Özür',
    'settings.templates.category.promotional': 'Promosyon',
    'settings.templates.category.general': 'Genel',

    'settings.saveChanges': 'Kaydet',
    'settings.saving': 'Kaydediliyor...',
    'settings.profileUpdated': 'Profil başarıyla güncellendi',
    'settings.passwordChanged': 'Şifre başarıyla değiştirildi',
    'settings.passwordHint': 'Şifrenizi değiştirmek istemiyorsanız şifre alanlarını boş bırakın.',
    'settings.security.atLeast8Chars': 'En az 8 karakter',
    'settings.security.containsLetterAndNumber': 'Harf ve rakam içermeli',
    'settings.security.passwordStrength': 'Şifre gücü',
    'settings.security.veryWeak': 'Çok Zayıf',
    'settings.security.weak': 'Zayıf',
    'settings.security.fair': 'Orta',
    'settings.security.good': 'İyi',
    'settings.security.strong': 'Güçlü',
    'settings.security.veryStrong': 'Çok Güçlü',
    
    // Common
    'common.save': 'Kaydet',
    'common.cancel': 'İptal',
    'common.delete': 'Sil',
    'common.edit': 'Düzenle',
    'common.create': 'Oluştur',
    'common.update': 'Güncelle',
    'common.settings': 'Ayarlar',
    'common.moreOptions': 'Diğer seçenekler',
    'common.search': 'Ara',
    'common.filter': 'Filtrele',
    'common.loading': 'Yükleniyor...',
    'common.and': 've',
    'common.error': 'Hata',
    'common.errorDescription': 'Veri yüklenirken bir hata oluştu. Lütfen tekrar deneyin.',
    'common.tryAgain': 'Tekrar Dene',
    'common.success': 'Başarılı',
    'common.noData': 'Veri bulunamadı',
    'common.user': 'Kullanıcı',
    'common.all': 'Tümü',
    'common.created': 'Oluşturulma',
    'common.export': 'Dışa Aktar',
    'common.refresh': 'Yenile',
    'common.sync': 'Senkronize et',
    'common.showing': 'Gösteriliyor',
    'common.of': '/',
    'common.page': 'Sayfa',
    'common.status': 'Durum',
    'common.add': 'Ekle',
    'common.remove': 'Kaldır',
    'common.info': 'Bilgi',
    'common.active': 'Aktif',
    'common.inactive': 'Pasif',
    'common.close': 'Kapat',
    'common.copy': 'Kopyala',
    'common.logout': 'Çıkış Yap',
    'common.name': 'Ad',
    'common.na': 'Yok',
    'common.validationError': 'Doğrulama Hatası',
    'common.validationErrorDescription': 'Lütfen form hatalarını düzeltin',
    'validation.required': 'Lütfen bu alanı doldurun',
    'validation.minLength': 'En az {min} karakter olmalıdır',
    'validation.maxLength': 'En fazla {max} karakter olabilir',
    'validation.invalidFormat': 'Geçersiz format',
    'auth.logout': 'Çıkış Yap',
    'auth.showPassword': 'Şifreyi göster',
    'auth.hidePassword': 'Şifreyi gizle',
    'auth.register.password': 'Şifre',
    'auth.register.passwordPlaceholder': 'En az 8 karakter',
    'auth.register.passwordMinLength': 'Şifre en az 8 karakter olmalıdır',
    'platform.comingSoon': 'Yakında',
    'error.boundary.title': 'Bir şeyler ters gitti',
    'error.boundary.description': 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
    'error.boundary.retry': 'Tekrar dene',
    'topbar.toggleSidebar': 'Kenar çubuğunu aç/kapat',
    'topbar.toggleCollapse': 'Kenar çubuğunu daralt',
    'topbar.languageMenu': 'Dil menüsü',
    'topbar.themeToggle': 'Temayı değiştir',
    'topbar.userMenu': 'Kullanıcı menüsü',
    'validation.email': 'Lütfen geçerli bir e-posta adresi girin',
    'validation.emailInvalid': 'Lütfen geçerli bir e-posta adresi girin',
    'validation.password': 'Lütfen bir şifre girin',
    'validation.passwordMinLength': 'Şifre en az 8 karakter olmalıdır',
    'validation.passwordFormat': 'Şifre en az bir harf ve bir rakam içermelidir',
    'validation.passwordsDoNotMatch': 'Şifreler eşleşmiyor',
    'validation.passwordsMatch': 'Şifreler eşleşiyor',
    'validation.currentPasswordRequired': 'Şifre değiştirmek için mevcut şifre gereklidir',
    'common.pending': 'Beklemede',
    'common.previous': 'Önceki',
    'common.next': 'Sonraki',
    'common.total': 'toplam',
    
    // Dashboard Page
    'dashboard.title': 'Kontrol Paneli',
    'dashboard.welcome': 'Tekrar hoş geldiniz',
    'dashboard.stats.description': 'İşletme performansınızın genel bakışı',
    'dashboard.stats.totalBusinesses': 'Toplam İşletme',
    'dashboard.stats.totalReviews': 'Toplam Yorum',
    'dashboard.stats.averageRating': 'Ortalama Puan',
    'dashboard.stats.positiveRatio': 'Pozitif Oran',
    'dashboard.stats.connectedPlatforms': 'Bağlı Platformlar',
    'dashboard.stats.activeSubscriptions': 'Aktif Abonelikler',
    'dashboard.stats.vsLastMonth': 'geçen aya göre',
    'dashboard.stats.outOf5': '5.0 üzerinden',
    'dashboard.stats.positiveReviews': 'pozitif yorumlar',
    'dashboard.stats.activeIntegrations': 'aktif entegrasyonlar',
    'dashboard.stats.currentPlans': 'mevcut planlar',
    'dashboard.stats.totalLocations': 'toplam lokasyon',
    'dashboard.recentReviews.title': 'Son Yorumlar',
    'dashboard.recentReviews.description': 'Tüm platformlardan son müşteri geri bildirimleri',
    'dashboard.recentReviews.empty': 'Henüz yorum yok',
    'dashboard.recentReviews.emptyDescription': 'Müşteriler geri bildirim bırakmaya başladığında yorumlar burada görünecek.',
    'dashboard.newBusinesses.title': 'Yeni İşletmeler',
    'dashboard.newBusinesses.description': 'İşletme lokasyonlarınız',
    'dashboard.newBusinesses.added': 'Eklendi',
    'dashboard.newBusinesses.connectedPlatforms': 'Bağlı Platformlar',
    'dashboard.newBusinesses.empty': 'Henüz işletme yok',
    'dashboard.newBusinesses.emptyDescription': 'Yorum yönetmeye başlamak için ilk işletme lokasyonunuzu ekleyin.',
    'dashboard.viewAll': 'Tümünü Gör',
    
    // System Admin Dashboard
    'dashboard.systemAdmin.title': 'Sistem Yönetimi',
    'dashboard.systemAdmin.welcome': 'Sistem yönetim paneline hoş geldiniz',
    'dashboard.systemAdmin.manageOrganizations': 'Tüm organizasyonları yönet',
    'dashboard.systemAdmin.manageUsers': 'Kullanıcıları görüntüle ve yönet',
    'dashboard.systemAdmin.pendingApprovals': 'Bekleyen onaylar',
    'dashboard.systemAdmin.systemSettings': 'Sistem ayarları',
    'dashboard.systemAdmin.allOrganizations': 'Tüm kayıtlı organizasyonlar',
    'dashboard.systemAdmin.activeOrganizations': 'Onaylanmış ve aktif',
    'dashboard.systemAdmin.awaitingApproval': 'Onay bekliyor',
    'dashboard.systemAdmin.allUsers': 'Tüm sistem kullanıcıları',
    'dashboard.systemAdmin.pendingRegistrations': 'Bekleyen Organizasyon Kayıtları',
    'dashboard.systemAdmin.pendingRegistrationsDescription': 'Onay bekleyen {count} organizasyon kaydı var.',
    'dashboard.systemAdmin.reviewPending': 'Bekleyen Kayıtları İncele',
    'dashboard.systemAdmin.quickActions': 'Hızlı İşlemler',
    'dashboard.systemAdmin.quickActionsDescription': 'Yaygın yönetim görevleri',
    'dashboard.systemAdmin.systemOverview': 'Sistem Genel Bakışı',
    'dashboard.systemAdmin.systemOverviewDescription': 'Mevcut sistem durumu ve istatistikleri',
    'common.view': 'Görüntüle',
    'common.viewDetails': 'Detayları Görüntüle',
    'common.readOnly': 'Salt okunur',
    'common.details': 'Detaylar',
    'common.createdAt': 'Oluşturulma Tarihi',
    'common.updatedAt': 'Güncellenme Tarihi',
    
    // Business Page
    'business.title': 'İşletmeler',
    'business.subtitle': 'İşletmelerinizi yönetin',
    'business.create': 'İşletme Oluştur',
    'business.name': 'İşletme Adı',
    'business.description': 'Açıklama',
    'business.address': 'Adres',
    'business.phone': 'Telefon',
    'business.phoneNumber': 'Telefon Numarası',
    'business.email': 'E-posta',
    'business.businessType': 'İşletme Türü',
    'business.website': 'Web Sitesi',
    'business.status': 'Durum',
    'business.active': 'Aktif',
    'business.inactive': 'Pasif',
    'business.actions': 'İşlemler',
    'business.edit': 'Düzenle',
    'business.delete': 'Sil',
    'business.noBusinesses': 'İşletme bulunamadı',
    'business.createNew': 'İlk işletmenizi oluşturun',
    'business.activate': 'Aktif Et',
    'business.deactivate': 'Pasif',
    'business.outOf': 'toplam',
    'business.acrossAll': 'tüm işletmelerde',
    'business.averageAcross': 'işletmeler arası ortalama',
    'business.type': 'İşletme Türü',
    'business.typeRestaurant': 'Restoran',
    'business.typeHotel': 'Otel',
    'business.typeRetail': 'Perakende',
    'business.typeHealthcare': 'Sağlık',
    'business.typeTechnology': 'Teknoloji',
    'business.typeEducation': 'Eğitim',
    'business.typeFinance': 'Finans',
    'business.typeOther': 'Diğer',
    'business.created': 'İşletme oluşturuldu',
    'business.createdDescription': 'İşletme başarıyla oluşturuldu.',
    'business.createFailed': 'İşletme oluşturulamadı.',
    'business.notFound': 'Organizasyon ID veya işletme bulunamadı',
    'business.updatedDescription': 'İşletme başarıyla güncellendi',
    'business.updateFailed': 'İşletme güncellenemedi',
    'business.activated': 'İşletme aktif edildi',
    'business.activatedDescription': 'İşletme başarıyla aktif edildi.',
    'business.deactivated': 'İşletme pasif edildi',
    'business.deactivatedDescription': 'İşletme başarıyla pasif edildi.',
    'business.statusUpdateFailed': 'İşletme durumu güncellenemedi',
    'business.deleted': 'İşletme silindi',
    'business.deletedDescription': 'İşletme başarıyla silindi.',
    'business.deleteFailed': 'İşletme silinemedi.',
    'business.organizationIdNotFound': 'Organizasyon ID bulunamadı',
    'business.activateConfirm': 'Bu işletmeyi aktif etmek istediğinizden emin misiniz?',
    'business.deactivateConfirm': 'Bu işletmeyi pasif etmek istediğinizden emin misiniz?',
    'business.deleteConfirm': 'Bu işletmeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    
    // Review Page
    'review.title': 'Yorumlar',
    'review.subtitle': 'Müşteri yorumlarını yönetin ve yanıtlayın',
    'review.selectAll': 'Tümünü seç',
    'review.filter': 'Filtrele',
    'review.search': 'Yorum ara',
    'review.platform': 'Platform',
    'review.rating': 'Puan',
    'review.date': 'Tarih',
    'review.customer': 'Müşteri',
    'review.comment': 'Yorum',
    'review.response': 'Yanıt',
    'review.respond': 'Yanıtla',
    'review.noReviews': 'Yorum bulunamadı',
    'review.aiAnalysis': 'AI Analizi',
    'review.analysis': 'AI Analizleri',
    'review.sentiment': 'Duygu',
    'review.positive': 'Pozitif',
    'review.neutral': 'Nötr',
    'review.negative': 'Negatif',
    'review.analyzed': 'Analiz Edildi',
    'review.thisMonth': 'Bu Ay',
    'review.sortBy': 'Sırala',
    'review.newestFirst': 'En Yeni',
    'review.oldestFirst': 'En Eski',
    'review.highestRating': 'En Yüksek Puan',
    'review.lowestRating': 'En Düşük Puan',
    'review.platformAZ': 'Platform A-Z',
    'review.analyzeSelected': 'Seçilenleri Analiz Et',
    'review.analyzePending': 'Bekleyen yorumları analiz et',
    'review.analysisUpToDate': 'Tüm yorumlar zaten analiz edildi',
    'review.analyze': 'Analiz et',
    'review.analyzing': 'Analiz ediliyor...',
    'review.aiAnalysisInProgress': 'AI bu yorumu analiz ediyor. Bu birkaç dakika sürebilir...',
    'review.pleaseWait': 'Lütfen yorumu analiz ederken bekleyin',
    'review.analysisComplete': 'Analiz Tamamlandı!',
    'review.analysisSuccess': 'Yorum başarıyla analiz edildi',
    'review.analysisCompleted': 'AI Analizi Tamamlandı',
    'review.analysisCompletedDescription': 'yorum başarıyla analiz edildi.',
    'review.analysisSingleCompleted': 'Yorum analiz edildi',
    'review.analysisSingleCompletedDescription': 'Bu yoruma AI içgörüleri eklendi.',
    'review.analysisStarted': 'Analiz başlatıldı',
    'review.analysisStartedDescription': 'yorum için AI analizi başlatıldı.',
    'review.exportStarted': 'Dışa aktarma başlatıldı',
    'review.exportStartedDescription': 'Yorum dışa aktarma işlemi başlatıldı.',
    'review.loadFailed': 'Yorumlar yüklenemedi',
    'review.star': 'Yıldız',
    'review.stars': 'Yıldız',
    'review.syncReviews': 'Yorumları Senkronize Et',
    'review.syncing': 'Senkronize ediliyor...',
    'review.syncSuccess': 'Yorumlar başarıyla senkronize edildi',
    'review.syncFailed': 'Yorumlar senkronize edilemedi',
    'review.reviewsSynced': 'yorum senkronize edildi',
    'review.noPlatformsConnected': 'Henüz platform bağlanmadı. Lütfen önce bir platform bağlayın.',
    'review.lastSynced': 'Son senkronizasyon',
    'review.never': 'Hiç',
    'review.syncOnePlatform': '1 Platformu Senkronize Et',
    'review.syncMultiplePlatforms': '{count} Platformu Senkronize Et',
    'review.noBusinessSelected': 'Lütfen önce bir işletme seçin',
    'review.selectOrganizationPrompt': 'Yorumları görüntülemek için lütfen bir organizasyon seçin',
    'review.showing': '{start} ile {end} arası gösteriliyor, toplam {total} yorum',
    'review.chooseAnalysisType': 'Analiz türünü seçin',
    'review.analyzeAll': 'Tüm Yorumları Analiz Et',
    'review.analysisFailed': 'Yorumlar analiz edilemedi',
    'review.exportFailed': 'Yorumlar dışa aktarılamadı.',
    'review.anonymous': 'Anonim',
    'review.averageRating': 'Ortalama Puan',
    'review.backToReviews': 'Yorumlara Dön',
    'review.details': 'Yorum Detayları',
    'review.reviewText': 'Yorum Metni',
    'review.aiAnalysisDescription': 'AI destekli duygu ve konu analizi',
    'review.topics': 'Konular',
    'review.summary': 'Özet',
    'review.responseSuggestions': 'Yanıt Önerileri',
    'review.reply.description': 'Bu Google yorumu için doğrudan yanıt gönderin.',
    'review.reply.placeholder': 'Yanıtınızı yazın...',
    'review.reply.alreadyResponded': 'Bu yoruma daha önce yanıt verilmiş.',
    'review.reply.repliedViaRevomira': 'Revomira üzerinden yanıtlandı',
    'review.reply.repliedOnGoogle': 'Google üzerinde yanıtlandı',
    'review.reply.update': 'Yanıtı Güncelle',
    'review.reply.replaceTitle': 'Mevcut yanıt değiştirilsin mi?',
    'review.reply.replaceWarning': 'Bu yorumun zaten bir yanıtı var. Yeni bir yanıt göndermek, platformdaki mevcut yanıtın yerine geçer. Devam etmek istiyor musunuz?',
    'review.reply.replaceConfirm': 'Yanıtı değiştir',
    'review.reply.successTitle': 'Başarılı',
    'review.reply.successDesc': 'Yanıt platforma gönderildi.',
    'review.reply.failedDesc': 'Yanıt gönderilemedi.',
    'review.reply.sending': 'Gönderiliyor...',
    'review.reply.send': 'Yanıt Gönder',
    'review.reply.chooseTemplate': 'Bir şablon seçin...',
    'review.reply.applyTemplate': 'Şablonu kullan',
    'review.reply.templateApplyFailed': 'Şablon uygulanamadı',
    'review.reply.generateAi': 'Yapay zeka yanıtı oluştur',
    'review.reply.aiGenerating': 'Oluşturuluyor...',
    'review.reply.aiGenerateFailed': 'Yapay zeka yanıtı oluşturulamadı',
    'review.confidence': 'güven',
    
    // AI Analysis - Sentiments
    'sentiment.positive': 'Pozitif',
    'sentiment.negative': 'Negatif',
    'sentiment.neutral': 'Nötr',
    'sentiment.mixed': 'Karışık',
    
    // AI Analysis - Topics
    'topic.service': 'Hizmet',
    'topic.quality': 'Kalite',
    'topic.staff': 'Personel',
    'topic.atmosphere': 'Atmosfer',
    'topic.price': 'Fiyat',
    'topic.location': 'Konum',
    'topic.cleanliness': 'Temizlik',
    'topic.food': 'Yemek',
    'topic.value': 'Değer',
    'topic.amenities': 'Olanaklar',
    'topic.overall_experience': 'Genel Deneyim',
    'topic.accommodation': 'Konaklama',
    
    // AI Analysis - Suggestion Categories
    'suggestionCategory.response': 'Yanıt',
    'suggestionCategory.improvement': 'İyileştirme',
    'suggestionCategory.action': 'Aksiyon',
    
    // AI Analysis - Priorities
    'priority.high': 'Yüksek',
    'priority.medium': 'Orta',
    'priority.low': 'Düşük',
    
    // AI Analysis - Tones
    'tone.apologetic': 'Özür Dileyen',
    'tone.grateful': 'Minnettar',
    'tone.neutral': 'Nötr',
    'tone.professional': 'Profesyonel',
    'review.platformRawData': 'Platform Ham Verisi',
    'review.originalReviewData': 'Orijinal yorum verisi',
    'review.downloadRawData': 'Ham Veriyi İndir (JSON)',
    'review.metadata': 'Meta Veri',
    'review.reviewId': 'Yorum ID',
    'review.platformReviewId': 'Platform Yorum ID',
    'review.syncedAt': 'Senkronize Edilme',
    'review.updatedAt': 'Güncellenme',
    'review.analysisResultId': 'Analiz Sonuç ID',
    'common.actions': 'İşlemler',
    'review.analyzeWithAI': 'AI ile Analiz Et',
    'review.analysisQueued': 'Bu yorum için AI analizi kuyruğa alındı',
    'review.viewAllReviews': 'Tüm Yorumları Görüntüle',
    'review.notFound': 'Yorum bulunamadı',
    'review.noComment': 'Yorum mevcut değil',
    
    // Organization Page
    'organization.title': 'Organizasyonlar',
    'organization.subtitle': 'Organizasyonları yönetin',
    'organization.create': 'Organizasyon Oluştur',
    'organization.name': 'Organizasyon Adı',
    'organization.contactEmail': 'İletişim E-postası',
    'organization.contactName': 'İletişim Adı',
    'organization.phoneNumber': 'Telefon Numarası',
    'organization.website': 'Web Sitesi',
    'organization.phoneNumberHint': 'Uluslararası format kullanın (örn: +905558883322)',
    'organization.status': 'Durum',
    'organization.pending': 'Beklemede',
    'organization.active': 'Aktif',
    'organization.inactive': 'Pasif',
    'organization.users': 'Kullanıcılar',
    'organization.businesses': 'İşletmeler',
    'organization.edit': 'Düzenle',
    'organization.delete': 'Sil',
    'organization.manage': 'Organizasyonları Yönet',
    'organization.manageUsers': 'Kullanıcıları Yönet',
    'organization.noOrganizations': 'Organizasyon bulunamadı',
    'organization.noUsers': 'Kullanıcı bulunamadı',
    'organization.stats.total': 'Toplam Organizasyon',
    'organization.stats.totalUsers': 'Toplam Kullanıcı',
    'organization.allUsers': 'Tüm Kullanıcılar',
    'organization.allUsersDescription': 'Tüm organizasyonlardaki kullanıcıları tek ekrandan yönetin.',
    'organization.admin': 'Organizasyon Yöneticisi',
    'organization.user': 'Organizasyon Kullanıcısı',
    'organization.userRemoveConfirm': 'Bu kullanıcıyı kaldırmak istediğinizden emin misiniz',
    'organization.userRemoved': 'Kullanıcı kaldırıldı',
    'organization.userRemovedDescription': 'Kullanıcı başarıyla kaldırıldı.',
    'organization.userRemoveFailed': 'Kullanıcı kaldırılamadı.',
    'organization.approve': 'Onayla',
    'organization.approveConfirm': 'Bu organizasyonu onaylamak istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    'organization.reject': 'Reddet',
    'organization.created': 'Organizasyon oluşturuldu',
    'organization.createdDescription': 'Organizasyon başarıyla oluşturuldu.',
    'organization.createFailed': 'Organizasyon oluşturulamadı.',
    'organization.updated': 'Organizasyon güncellendi',
    'organization.updatedDescription': 'Organizasyon başarıyla güncellendi.',
    'organization.updateFailed': 'Organizasyon güncellenemedi.',
    'organization.deleteConfirm': 'Bu organizasyonu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz:',
    'organization.deleted': 'Organizasyon silindi',
    'organization.deletedDescription': 'Organizasyon başarıyla silindi.',
    'organization.deleteFailed': 'Organizasyon silinemedi.',
    'organization.role': 'Rol',
    'organization.approved': 'Organizasyon onaylandı',
    'organization.approvedDescription': 'Organizasyon başarıyla onaylandı.',
    'organization.approveFailed': 'Organizasyon onaylanamadı.',
    'organization.rejected': 'Organizasyon reddedildi',
    'organization.rejectedDescription': 'Organizasyon reddedildi.',
    'organization.rejectFailed': 'Organizasyon reddedilemedi.',
    'organization.status.approved': 'Onaylandı',
    'organization.status.pending': 'Beklemede',
    'organization.status.rejected': 'Reddedildi',
    'organization.status.active': 'Aktif',
    'organization.status.inactive': 'Pasif',
    'organization.pendingRequests': 'Bekleyen kayıtlar',
    'organization.pendingHelp': 'Gelen organizasyon başvurularını inceleyin ve erişim vermek için onaylayın.',
    'organization.requestedOn': 'Talep tarihi',
    'organization.contact': 'İletişim',
    'organization.noPending': 'Şu anda bekleyen kayıt yok.',
    'organization.selectOrganization': 'Organizasyon seç',
    'organization.selectOrganizationHelp': 'İşletmeleri ve incelemeleri yönetmek için bir organizasyon seçin.',
    'organization.noOrganizationAvailable': 'Henüz herhangi bir organizasyon yok. Önce bekleyen başvuruyu onaylayın.',
    'business.selectBusiness': 'İşletme seç',
    'business.selectBusinessHelp': 'Görüntülemek istediğiniz işletmeyi seçin.',
    'business.noBusinessAvailable': 'Bu organizasyona ait işletme bulunmuyor.',
    
    // Subscription Page
    'subscription.title': 'Abonelik',
    'subscription.subtitle': 'Abonelik planınızı yönetin',
    'subscription.currentPlan': 'Mevcut Plan',
    'subscription.upgrade': 'Yükselt',
    'subscription.downgrade': 'Düşür',
    'subscription.cancel': 'Aboneliği İptal Et',
    'subscription.renew': 'Yenile',
    'subscription.active': 'Aktif',
    'subscription.cancelled': 'İptal Edildi',
    'subscription.trial': 'Deneme',
    'subscription.inactive': 'Pasif',
    'subscription.expired': 'Süresi Dolmuş',
    'subscription.planBasic': 'Temel Plan',
    'subscription.planProfessional': 'Profesyonel Plan',
    'subscription.planEnterprise': 'Kurumsal Plan',
    'subscription.nextBilling': 'Sonraki Faturalama Tarihi',
    'subscription.noSubscription': 'Aktif abonelik yok',
    'subscription.upgradePlan': 'Planı Yükselt',
    'subscription.monthly': 'Aylık',
    'subscription.yearly': 'Yıllık',
    'subscription.billing': 'faturalama',
    'subscription.per': 'başına',
    'subscription.month': 'ay',
    'subscription.year': 'yıl',
    'subscription.planFeatures': 'Plan Özellikleri',
    'subscription.usageLimits': 'Kullanım Limitleri',
    'subscription.billingInfo': 'Faturalama Bilgisi',
    'subscription.started': 'Başlangıç',
    'subscription.updatePaymentMethod': 'Ödeme Yöntemini Güncelle',
    'subscription.noActiveSubscription': 'Aktif Abonelik Yok',
    'subscription.noActiveSubscriptionDescription': 'Aktif bir aboneliğiniz yok. Başlamak için bir plan seçin.',
    'subscription.choosePlan': 'Plan Seç',
    'subscription.noSubscriptions': 'Abonelik bulunamadı',
    'subscription.nearLimit': 'Plan limitinize yaklaştınız.',
    'subscription.limitReached': 'Plan limitine ulaşıldı.',
    'subscription.history': 'Abonelik Geçmişi',
    'subscription.historyDescription': 'Abonelik değişiklikleriniz ve faturalama geçmişiniz',
    'subscription.usage': 'Kullanım Özeti',
    'subscription.plan': 'Plan',
    'subscription.billingCycle': 'Faturalama Döngüsü',
    'subscription.price': 'Fiyat',
    'subscription.startDate': 'Başlangıç Tarihi',
    'subscription.endDate': 'Bitiş Tarihi',
    'subscription.trialEndDate': 'Deneme Bitiş Tarihi',
    'subscription.reactivate': 'Yeniden Aktif Et',
    'subscription.billingHistory': 'Faturalama Geçmişi',
    'subscription.upgraded': 'Abonelik yükseltildi',
    'subscription.upgradedDescription': 'Aboneliğiniz başarıyla yükseltildi.',
    'subscription.cancelledToast': 'Abonelik iptal edildi',
    'subscription.cancelledDescription': 'Aboneliğiniz iptal edildi. Faturalama döneminin sonuna kadar hizmeti kullanmaya devam edebilirsiniz.',
    'subscription.reactivated': 'Abonelik yeniden aktif edildi',
    'subscription.reactivatedDescription': 'Aboneliğiniz başarıyla yeniden aktif edildi.',
    'subscription.cancelConfirm': 'Aboneliğinizi iptal etmek istediğinizden emin misiniz?',
    'subscription.cancelConfirmDescription': 'Faturalama döneminin sonuna kadar hizmeti kullanmaya devam edebilirsiniz.',
    'subscription.keepSubscription': 'Aboneliği Koru',
    'subscription.upgradeFailed': 'Abonelik yükseltilemedi.',
    'subscription.cancelFailed': 'Abonelik iptal edilemedi.',
    'subscription.reactivateFailed': 'Abonelik yeniden aktif edilemedi.',
    'subscription.downloadInvoiceFailed': 'Fatura indirilemedi.',
    'subscription.upgradeTo': 'Yükselt',
    'subscription.description': 'Açıklama',
    'subscription.amount': 'Tutar',
    'subscription.invoiceDownloaded': 'Fatura indirildi',
    'subscription.invoiceDownloadedDescription': 'Fatura başarıyla indirildi.',
    'subscription.paid': 'Ödendi',
    'subscription.failed': 'Başarısız',
    'subscription.loadFailed': 'Abonelik verileri yüklenemedi',
    
    // Charts
    'charts.reviewSentiment': 'Yorum Duygusu',
    'charts.sentimentDescription': 'Pozitif, nötr ve negatif yorumların dağılımı',
    'charts.reviewsOverTime': 'Zaman İçinde Yorumlar',
    'charts.reviewsOverTimeDescription': 'Son 30 günün yorum trendleri',
    'charts.businessPerformance': 'İşletme Performansı',
    'charts.businessPerformanceDescription': 'İşletme performans metrikleri',
    'charts.noBusinessData': 'İşletme verisi bulunamadı',
    'charts.addBusinesses': 'Performans metriklerini görmek için işletme ekleyin',
    'charts.platformActivity': 'Platform Aktivitesi',
    'charts.platformActivityDescription': 'Platformlar arası yorum dağılımı',
    'charts.noPlatformData': 'Platform verisi bulunamadı',
    'charts.connectPlatforms': 'Aktiviteyi görmek için platform bağlayın',
    'charts.percentage': 'Yüzde',
    
    // Analytics
    'analytics.advancedAnalytics': 'Gelişmiş Analitikler',
    'analytics.advancedAnalyticsDescription': 'Trend analizi, insightlar ve konu tespiti',
    'analytics.sentimentTrend': 'Sentiment Trendi',
    'analytics.sentimentTrendDescription': 'Zaman içinde sentiment analizi',
    'analytics.sentimentChange': 'sentiment değişimi',
    'analytics.sentiment': 'Sentiment',
    'analytics.insights': 'Aksiyon Alınabilir Insightlar',
    'analytics.insightsDescription': 'Önemli trendler ve öneriler',
    'analytics.noInsights': 'Henüz insight bulunmuyor. Yorumları analiz edin.',
    'analytics.suggestion': 'Öneri',
    'analytics.topKeywords': 'En Çok Geçen Kelimeler',
    'analytics.topKeywordsDescription': 'Yorumlarda en çok bahsedilen anahtar kelimeler',
    'analytics.noKeywords': 'Henüz keyword bulunmuyor. Yorumları analiz edin.',
    'analytics.topics': 'Konu Analizi',
    'analytics.topicsDescription': 'En çok bahsedilen konular ve problem alanları',
    'analytics.noTopics': 'Henüz topic bulunmuyor. Yorumları analiz edin.',
    'analytics.problemAreas': 'Problem Alanları',
    'analytics.positiveTopics': 'Pozitif Konular',
    'analytics.mentionedIn': 'Bahsedildi',
    'analytics.topicMentions': 'Konu Bahsedilmeleri',
    'analytics.mentions': 'Bahsedilme',
    'analytics.noTrendData': 'Trend verisi bulunamadı',
    'analytics.analyzeReviews': 'Trendleri görmek için yorumları analiz edin',
    'analytics.noBusinessSelected': 'Analitikleri görmek için bir işletme seçin',
    'analytics.selectBusiness': 'Analitik işletmesi',
    'common.count': 'Sayı',
    
    // Business Detail Page
    'businessDetail.loadFailed': 'İşletme verileri yüklenemedi',
    'businessDetail.notFound': 'İşletme Bulunamadı',
    'businessDetail.notFoundDescription': 'Aradığınız işletme mevcut değil veya erişiminiz yok.',
    'businessDetail.backToBusinesses': 'İşletmelere Dön',
    'businessDetail.connectPlatform': 'Platform Bağla',
    'businessDetail.fromBusinessData': 'işletme verisinden',
    'businessDetail.connectedPlatforms': 'Bağlı Platformlar',
    'businessDetail.connectedPlatformsDescription': 'Platform entegrasyonlarınızı ve yorum kaynaklarınızı yönetin',
    'businessDetail.connected': 'Bağlandı',
    'businessDetail.recently': 'Yakın zamanda',
    'businessDetail.sync': 'Senkronizasyon',
    'businessDetail.every': 'Her',
    'businessDetail.hours': 'saatte bir',
    'businessDetail.lastSync': 'Son senkronizasyon',
    'businessDetail.never': 'Hiç',
    'businessDetail.disconnect': 'Bağlantıyı Kes',
    'businessDetail.noPlatforms': 'Henüz platform bağlanmadı',
    'businessDetail.noPlatformsDescription': 'İlk platform entegrasyonunuzu eklemek için "Platform Bağla"ya tıklayın',
    'businessDetail.recentReviews': 'Son Yorumlar',
    'businessDetail.recentReviewsDescription': 'En son müşteri geri bildirimleri ve AI analizi',
    'businessDetail.viewDetails': 'Detayları Görüntüle',
    'businessDetail.connectNewPlatform': 'Yeni Platform Bağla',
    'businessDetail.businessSettings': 'İşletme Ayarları',
    'businessDetail.missingAuthCode': 'Yetkilendirme Kodu Eksik',
    'businessDetail.missingAuthCodeDescription': 'Lütfen platformdan geçerli bir yetkilendirme kodu sağlayın.',
    'businessDetail.platformConnected': 'Platform bağlandı',
    'businessDetail.platformConnectedDescription': 'başarıyla bağlandı.',
    'businessDetail.connectFailed': 'Platform bağlanamadı.',
    'businessDetail.analysisStartedDescription': 'AI analizi arka planda çalışıyor.',
    'businessDetail.settingsSaved': 'Ayarlar kaydedildi',
    'businessDetail.settingsSavedDescription': 'İşletme ayarları başarıyla güncellendi.',
    'businessDetail.settingsSaveFailed': 'İşletme ayarları kaydedilemedi.',
    'businessDetail.platformSettingsSaved': 'Platform ayarları kaydedildi',
    'businessDetail.platformSettingsSavedDescription': 'ayarları başarıyla güncellendi.',
    'businessDetail.platformSettingsSaveFailed': 'Platform ayarları kaydedilemedi.',
    'businessDetail.disconnectConfirm': 'Bağlantıyı kesmek istediğinizden emin misiniz',
    'businessDetail.disconnectConfirmDescription': 'Bu, bu platformdan yorum senkronizasyonunu durduracak.',
    'businessDetail.platformDisconnected': 'Platform bağlantısı kesildi',
    'businessDetail.platformDisconnectedDescription': 'başarıyla bağlantısı kesildi.',
    'businessDetail.disconnectFailed': 'Platform bağlantısı kesilemedi.',
    'businessDetail.selectPlatform': 'Bir platform seçin',
    'businessDetail.authorizationCode': 'Yetkilendirme Kodu',
    'businessDetail.authorizationCodePlaceholder': 'Platformdan yetkilendirme kodunu girin',
    'businessDetail.authorizationCodeHint': 'Bu kodu platformun OAuth akışından alın',
    'businessDetail.redirectUri': 'Yönlendirme URI',
    'businessDetail.redirectUriHint': 'OAuth akışında kullanılan yönlendirme URI',
    'businessDetail.oauthSupported': 'Bu platform OAuth kimlik doğrulamayı destekliyor. Otomatik olarak bağlanmak için aşağıdaki butona tıklayın.',
    'businessDetail.connectWithOAuth': 'OAuth ile Bağlan',
    'businessDetail.selectPlatformFirst': 'Lütfen önce bir platform seçin',
    'businessDetail.popupBlocked': 'Popup engellendi. Lütfen bu site için popup\'ları etkinleştirin ve tekrar deneyin.',
    'businessDetail.oauthCancelled': 'OAuth yetkilendirme iptal edildi',
    'businessDetail.oauthFailed': 'OAuth yetkilendirme başarısız oldu',
    'businessDetail.notificationEmail': 'Bildirim E-postası',
    'businessDetail.enableAiAnalysis': 'AI Analizini Etkinleştir',
    'businessDetail.enableAutoResponse': 'Otomatik Yanıtı Etkinleştir',
    'businessDetail.syncFrequency': 'Senkronizasyon Sıklığı (Saat)',
    'businessDetail.responseTemplate': 'Yanıt Şablonu',
    'businessDetail.responseTemplatePlaceholder': 'Yanıt şablonunuzu girin...',
    'businessDetail.every6Hours': 'Her 6 Saatte Bir',
    'businessDetail.every12Hours': 'Her 12 Saatte Bir',
    'businessDetail.daily24Hours': 'Günlük (24 Saat)',
    'businessDetail.syncFrequencyHint': 'Bu platformdan yorumların ne sıklıkla senkronize edileceği',
    'businessDetail.googleLocationNotConnected': 'Google My Business konumu bağlı değil',
    'businessDetail.connectBusiness': 'İşletme Bağla',
    'businessDetail.googleLocationConnected': 'Konum bağlandı',
    'businessDetail.failedToFetchGoogleAccounts': 'Google hesapları ve konumları alınamadı',
    'businessDetail.noGoogleAccountsFound': 'Google My Business hesabı bulunamadı',
    'businessDetail.accessToken': 'Erişim Token',
    'businessDetail.accessTokenPlaceholder': 'Yeni erişim token girin (isteğe bağlı)',
    'businessDetail.accessTokenHint': 'Mevcut token\'ı korumak için boş bırakın',
    'businessDetail.refreshToken': 'Yenileme Token',
    'businessDetail.refreshTokenPlaceholder': 'Yeni yenileme token girin (isteğe bağlı)',
    'businessDetail.refreshTokenHint': 'Mevcut token\'ı korumak için boş bırakın',
    'businessDetail.savePlatformSettings': 'Platform Ayarlarını Kaydet',
    'businessDetail.unknownBusiness': 'Bilinmeyen İşletme',
    'businessDetail.noDescription': 'Açıklama mevcut değil',
    'businessDetail.viewAllReviews': 'Tüm Yorumları Görüntüle',
    'businessDetail.noReviews': 'Yorum bulunmuyor',
    'businessDetail.reconnectPlatform': 'Platformu Yeniden Bağla',
    'businessDetail.selectGoogleLocation': 'Google My Business Konumu Seç',
    'businessDetail.selectGoogleAccount': 'Google Hesabı Seç',
    'businessDetail.selectAccount': 'Bir hesap seçin',
    'businessDetail.selectLocation': 'Bir konum seçin',
    'businessDetail.noLocationsFound': 'Bu hesap için konum bulunamadı',
    'businessDetail.selectAndConnect': 'Seç ve Bağla',
    'businessDetail.googleLocationSelected': 'Google My Business konumu başarıyla seçildi',
    'businessDetail.locationSelectionFailed': 'Konum seçimi başarısız oldu',
    'platform.connectionExpiredTitle': 'Platform Bağlantısının Süresi Doldu',
    'platform.connectionExpiredDescription': 'Yorumları senkronize etmeye devam etmek için lütfen platformu yeniden bağlayın.',
    'platform.connectionIssue.accessExpired': 'Erişim token süresi doldu',
    'platform.connectionIssue.refreshMissing': 'Yenileme token eksik veya geçersiz',
    'platform.locationNotFoundTitle': 'İşletme Konumu Bulunamadı',
    'platform.locationNotFoundDescription': 'İşletme konumu Google My Business\'ta bulunamadı. Lütfen işletmenin Google My Business\'ta düzgün şekilde kurulduğunu doğrulayın ve tekrar deneyin.',
    'invitations.pageTitle': 'Daveti Kabul Et',
    'invitations.title': 'Ekip Daveti',
    'invitations.description': 'Revomira\'da bir kuruluşa katılmaya davet edildiniz.',
    'invitations.checking': 'Davet kontrol ediliyor...',
    'invitations.needsLoginDescription': 'Bu daveti kabul etmek için giriş yapın veya bir hesap oluşturun.',
    'invitations.logInToContinue': 'Devam Etmek İçin Giriş Yap',
    'invitations.accept': 'Kabul Et',
    'invitations.decline': 'Reddet',
    'invitations.acceptedTitle': 'Davet Kabul Edildi',
    'invitations.acceptedDescription': 'Kuruluşa katıldınız.',
    'invitations.declinedTitle': 'Davet Reddedildi',
    'invitations.goToDashboard': 'Panele Git',
    'invitations.backToHome': 'Ana Sayfaya Dön',
    'invitations.missingToken': 'Bu davet bağlantısında token eksik.',
    'invitations.acceptFailed': 'Geçersiz veya süresi dolmuş davet.',
    'invitations.declineFailed': 'Geçersiz veya süresi dolmuş davet.',
};
